module.exports = __webpack_public_path__ + "img/cn_pocket-16.a1102c8.jpg";